import { Component } from '@angular/core';
import { SousTitreBlocComponent } from '../sous-titre-bloc/sous-titre-bloc.component';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-bloc-wheel',
    templateUrl: './bloc-wheel.component.html',
    styleUrls: ['./bloc-wheel.component.scss'],
    imports: [SousTitreBlocComponent, TranslocoModule]
})
export class BlocWheelComponent {

}
